import { SxProps, Theme } from '@mui/material';

export const loadingSx: SxProps<Theme> = {
	zIndex: (theme) => theme.zIndex.modal + 1,
	color: '#f96302',
};
